// extracted by mini-css-extract-plugin
module.exports = {"bar":"TabBar_bar__qnATI","tab":"TabBar_tab__2p1V2","tabSelected":"TabBar_tabSelected__32oJU"};